<template>
    <div id="report-agent-performance">
        <div class="overall-content">
            <div class="chart-container">
                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon resolve-icon">
                            <md-icon>speed</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.chatResolveTimeByAgent') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.resolveTimeByUserDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <ResolveTimeByUser
                            :title="$t('report.chatResolveTimeByAgent')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.resolveTime"
                        />
                    </div>
                </div>

                <div class="report-card">
                    <div class="report-card-header">
                        <div class="report-card-icon first-answer-icon">
                            <md-icon>quickreply</md-icon>
                        </div>
                        <div class="report-card-title">
                            <h2>{{ $t('report.firstAnswerByAgent') }}</h2>
                            <p class="report-card-subtitle">{{ $t('report.firstAnswerByAgentDesc') }}</p>
                        </div>
                    </div>
                    <div class="report-card-body">
                        <FirstInteractionTimeByUser
                            :title="$t('report.firstAnswerByAgent')"
                            :filters="filters"
                            :loading="loading"
                            :data="data.firstInteraction"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ResolveTimeByUser from "./ResolveTimeByUser.vue";
import FirstInteractionTimeByUser from "./FirstInteractionTimeByUser.vue";

const log = log2("AgentPerformance");
export default {
    name: "AgentPerformance",
    components: {
        FirstInteractionTimeByUser,
        ResolveTimeByUser,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                firstInteraction: null,
                resolveTime: null,
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            REPORT_API.agentPerformanceAll(this.filters)
                .then((res) => {
                    log("agentPerformanceAll data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
#report-agent-performance {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .overall-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        background: var(--color-bg-neutral, #f5f5f5);
        width: 100%;
        min-height: 100vh;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;

            .report-card {
                background: #fff;
                border-radius: 12px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
                overflow: hidden;
                transition: box-shadow 0.2s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
                }

                .report-card-header {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 20px 24px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.06);

                    .report-card-icon {
                        width: 44px;
                        height: 44px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        i {
                            font-size: 22px !important;
                            color: #fff;
                        }

                        &.resolve-icon {
                            background: linear-gradient(135deg, #f59e0b, #d97706);
                        }

                        &.first-answer-icon {
                            background: linear-gradient(135deg, #10b981, #059669);
                        }
                    }

                    .report-card-title {
                        h2 {
                            font-size: 18px;
                            font-weight: 600;
                            margin: 0;
                            color: #1a1a1a;
                        }

                        .report-card-subtitle {
                            font-size: 13px;
                            color: #6b7280;
                            margin: 2px 0 0 0;
                        }
                    }
                }

                .report-card-body {
                    padding: 20px 24px;
                }
            }
        }
    }
}
</style>
